import React from "react";
import { useNavigate } from "react-router-dom";
import SwoodleLogo from "../../../Assets/Icons/SwoodleUpdatedLogo.svg";
import PrimaryButton from "../PrimaryButton";
import OTP from "../OTP.jsx";
import SwoodleFooter from "../SwoodleFooter";
import LoginHeader from "../LoginHeader";
import { useFormik } from "formik";
import { otpSchema } from "../../../utils/validationSchemas";
import { useDispatch, useSelector } from "react-redux";
import {
  forgetPassword,
  otpVerification,
} from "../../../services/authService.js";
import { setForgetPasswordData } from "../../../redux/slices/authSlice";

const responsiveShellStyle = {
  width: "100%",
  maxWidth: "min(1920px, calc(100vw - 2vw))",
  margin: "0 auto",
};

const OTPVerification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const forgetData = useSelector(
    (state) => state?.authReducer?.forgetPasswordData
  );

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: otpSchema,
    onSubmit: async (values) => {
      try {
        const otpPromise = await dispatch(
          otpVerification({ otp: values?.otp, email: forgetData?.email })
        )?.unwrap();
        if (otpPromise?.success == true) {
          navigate("/reset-password");
        }
      } catch (error) {
        console.log("---err---", error);
      }
      // Handle form submission
      console.log(values);
    },
  });

  const { otp } = formik.values;

  const {
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    setFieldValue,
  } = formik;

  const onOtpChange = (otpValue) => {
    setFieldValue("otp", otpValue);
  };

  const handleResendClick = async () => {
    setFieldValue("otp", "");
    const forgetPromise = await dispatch(
      forgetPassword({ email: forgetData?.email })
    )?.unwrap();
    if (forgetPromise?.success === true) {
      dispatch(setForgetPasswordData({ email: forgetData?.email }));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="min-h-screen bg-white flex flex-col">
        <div className="w-full px-6 py-4">
          <div style={responsiveShellStyle}>
            <LoginHeader />
          </div>
        </div>

        <div className="flex-1 w-full flex flex-col items-center">
          <div className="w-full max-w-[640px] px-12 mt-10">
            <h2 className="text-center text-[24px] md:text-[26px] font-[700] font-poppins text-[#303030]">OTP Verification</h2>
            <p className="text-center text-[#8C8C8C] mt-2">Enter the 6 digit numbers sent to your email.</p>

            <div className="relative -translate-y-6 pb-3">
              <div className="mt-1 flex justify-center">
                <OTP
                  value={otp}
                  handleChange={onOtpChange}
                  inputStyle={{
                    border: "none",
                    borderRadius: "8px",
                    width: "44px",
                    height: "52px",
                    fontFamily: "Inter, sans-serif",
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#000000",
                    background: "#F2F4F5",
                    fontWeight: "600",
                    caretColor: "#303030",
                    outline: "none",
                  }}
                />
              </div>

              <p className="text-center text-[14px] font-poppins text-[#303030] font-[500] mt-4">Don't Receive Code? <span className="text-[#00ADEF] underline font-[600] cursor-pointer" onClick={handleResendClick}>Resend Code</span></p>
            </div>

            <div className="mt-4 flex justify-center">
              <PrimaryButton
                type="submit"
                className="w-[360px] sm:w-[420px] md:w-[460px] h-[60px] rounded-[8px] font-[600]"
                label="Set New Password"
              />
            </div>
          </div>
        </div>

        <div className="mt-16">
          <SwoodleFooter containerStyle={responsiveShellStyle} enableEntranceAnimation={true} />
        </div>
      </div>
    </form>
  );
};

export default OTPVerification;
